/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetApiV2OrganizationsByIdParams,
  PutApiV2OrganizationsByIdParams,
  DeleteApiV2OrganizationsByIdParams,
  PutApiV2OrganizationsByIdBody,
  PostApiV2OrganizationsBody,
  GetApiV2OrganizationsByIdResponse,
  PutApiV2OrganizationsByIdResponse,
  PostApiV2OrganizationsResponse,
  GetApiV2OrganizationsMyResponse,
} from '../types';

export class Organizations extends Controller {
  async getApiV2OrganizationsById<
    T extends GetApiV2OrganizationsByIdResponse,
    D,
    C
  >(
    { id }: GetApiV2OrganizationsByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${id}`,
      axiosConfig
    );
  }

  async putApiV2OrganizationsById<
    T extends PutApiV2OrganizationsByIdResponse,
    D,
    C extends PutApiV2OrganizationsByIdBody
  >(
    body: C,
    { id }: PutApiV2OrganizationsByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${id}`,
      body,
      axiosConfig
    );
  }

  async deleteApiV2OrganizationsById<T, D, C extends null>(
    { id }: DeleteApiV2OrganizationsByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${id}`,
      { ...axiosConfig, data: body }
    );
  }

  async postApiV2Organizations<
    T extends PostApiV2OrganizationsResponse,
    D,
    C extends PostApiV2OrganizationsBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/api/v2/organizations',
      body,
      axiosConfig
    );
  }

  async getApiV2OrganizationsMy<
    T extends GetApiV2OrganizationsMyResponse,
    D,
    C
  >(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/api/v2/organizations/my',
      axiosConfig
    );
  }
}
